<template>
  <div class="page organisation">
    <div class="content">
      <div class="back" @click="$router.go(-1)">
        <div class="icon-chevron left" />
        <div class="text">{{ $t('profil.goBack') }}</div>
      </div>
    </div>
    <div class="flex-line">
      <div class="section-title">{{ $t('profil.title') }}</div>
      <div class="disconnect" @click="logout"><doorOutIcon class="icon" />{{ $t('profil.logout') }}</div>
    </div>
    <div class="content section">
      <div class="title">{{ $t('profil.personalInfo') }}</div>
      <div class="row">
        <div class="col">
          <div class="title">{{ $t('profil.firstname') }}</div>
          <input id="firstname" v-model="firstname" type="text" name="firstname" class="text-input opacity" />
        </div>
        <div class="col">
          <div class="title">{{ $t('profil.lastname') }}</div>
          <input id="lastname" v-model="lastname" type="text" name="lastname" class="text-input opacity" />
        </div>
      </div>
      <div class="row" :class="{ 'margin-bottom': organization }">
        <div class="col">
          <div class="title">{{ $t('profil.phone') }}</div>
          <input
            id="cellphone"
            v-model="cellphone"
            type="text"
            name="cellphone"
            :class="{ invalid: !checkPhoneNumber && isSend }"
            class="text-input opacity"
          />
        </div>
        <div class="col">
          <div class="title">{{ $t('profil.mail') }}</div>
          <div class="disconnection">
            <input id="mail" v-model="mail" type="text" name="mail" class="text-input opacity nomargin" disabled />
          </div>
        </div>
      </div>
      <div v-if="organization" class="title">
        {{ $t('profil.myOrganization') }}
      </div>
      <div v-if="organization" class="row organisation-section">
        <div v-if="organization.logoLink" class="col">
          <div class="img selected" :style="{ 'background-image': `url(${organization.logoLink})` }"></div>
        </div>
        <div class="col organisation">
          <div class="organisation-name">{{ organization.name }}</div>
          <div class="organisation-address">{{ organization.address }}</div>
          <div v-if="since" class="organisation-member-since">
            {{ $t('profil.memberSince', { since: formatDate(since) }) }}
          </div>
          <div class="row">
            <div class="main-button button-create edit" @click="$router.push({ name: 'editOrganisation' })">
              <pen class="icon" /><span>{{ $t('profil.modify') }}</span>
            </div>
            <div class="leave-orga" @click.stop="leaveOrga">
              <doorOutIcon class="icon" />{{ $t('profil.leaveOrganization') }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content submit">
      <div class="main-button button-cancel" @click="$router.push({ name: 'dashboard' })">
        <div class="text">{{ $t('profil.cancelButton') }}</div>
      </div>
      <div class="main-button button-create" @click="updateProfil">
        <div class="text">{{ $t('profil.confirmButton') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatDate } from '@/libraries/formatter';
import doorOutIcon from '@/assets/icons/doorOut.svg';
import pen from '@/assets/listing/pen.svg';
export default {
  name: 'ProfileView',
  components: {
    doorOutIcon,
    pen,
  },
  data: function () {
    return {
      firstname: '',
      lastname: '',
      cellphone: '',
      mail: '',
      formatDate,
      isSend: false,
    };
  },

  computed: {
    ...mapGetters(['organization', 'user']),
    since() {
      return this.organization ? this.organization.users.find(e => e.id === this.user?.id).since : null;
    },
    checkPhoneNumber() {
      if (!this.cellphone) {
        return true;
      }
      let regex = /^((\+)33|0|0033|(\+)33\(0\))[1-9](\d{2}){4}$/;
      return regex.test(this.cellphone.split(' ').join(''));
    },
  },

  created() {
    this.$store.dispatch('organization.fetch');
  },

  async mounted() {
    this.firstname = this.user.firstName;
    this.lastname = this.user.lastName;
    this.mail = this.user.email;
    this.cellphone = this.user.phoneNumber;
  },

  methods: {
    async logout() {
      await this.$store.dispatch('auth.logout');
      this.$router.push({ name: 'home' });
    },
    async leaveOrga() {
      try {
        const result = await this.$store.dispatch('setPopup', {
          popupType: 'ConfirmPopup',
          popupData: {
            title: `QUITTER ${this.organization.name}`,
            content: `Vous perdrez l’accès aux dossiers de compétences de l’organisation`,
            company: this.organization.name,
            confirm: 'QUITTER',
          },
        });
        if (result) {
          await this.$store.dispatch('organization.kickUser', this.user.id);
          await this.$store.dispatch('auth.updateUser');
          this.$router.push({ name: 'dashboard' });
        }
      } catch (e) {
        console.error(e);
      }
    },
    async updateProfil() {
      this.isSend = true;
      try {
        await this.$store.dispatch('contacts.patchUser', {
          id: this.user.id,
          Firstname: this.firstname,
          Lastname: this.lastname,
          PhoneNumber: this.cellphone,
        });
        await this.$store.dispatch('auth.updateUser');
        this.$router.push({ name: 'dashboard' });
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive/profile.scss';

.organisation {
  padding: 96px 0 0;

  .flex-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    min-width: 700px;
    width: 60%;
    margin: auto;

    .section-title {
      color: colors.$light-blue-color;
      font-size: 36px;
      font-weight: 600;
    }

    .disconnect {
      font-size: 16px;
      font-weight: bold;
      margin-top: 12px;
      align-self: flex-end;
      cursor: pointer;
      display: flex;
      align-items: center;
      color: red;
      transition: all 0.3s;
      padding-right: 5px;

      &:hover {
        text-decoration: underline;
      }

      > .icon {
        color: red;
      }
    }
  }

  .content {
    min-width: 700px;
    width: 60%;
    padding: 16px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;

    .back {
      color: colors.$light-blue-color;
      font-size: 11px;
      font-weight: bold;
      display: flex;
      align-items: center;
      cursor: pointer;
      padding: 5px;

      &:hover {
        border-radius: 3px;
        background-color: rgba(colors.$light-blue-color, 0.15);
      }

      .text {
        margin-left: 4px;
      }
    }

    &.title {
      color: colors.$light-blue-color;
      font-size: 36px;
      font-weight: 600;
    }

    &.section {
      border-radius: 7px;
      background-color: colors.$white-color;
      box-shadow: 0 1px 7px 0 rgba(167, 167, 167, 0.5);
      padding: 38px 48px 34px 48px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      .title {
        color: #000000;
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 24px;
      }

      .row {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        width: 100%;

        &.margin-bottom {
          padding-bottom: 32px;
          margin-bottom: 22px;
          position: relative;
          &::after {
            position: absolute;
            height: 1px;
            background: colors.$grey-background-color;
            content: '';
            bottom: 0;
            right: 0;
            left: 0;
          }
        }

        .col {
          display: flex;
          align-items: flex-start;
          justify-content: flex-start;
          flex-direction: column;
          height: 100%;

          &.organisation {
            padding: 0;
            height: 119px;
            justify-content: space-between;
          }

          .img {
            box-sizing: border-box;
            height: 123px;
            width: 123px;
            border: 1px dashed colors.$secondary-color;
            border-radius: 11px;
            background-color: #fffcf5;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;

            &.selected {
              border: 0;
              position: relative;
            }
          }

          .title {
            color: #939292;
            font-size: 16px;
            font-weight: initial;
            margin-bottom: 6px;
          }

          .organisation-name {
            color: #000000;
            font-size: 18px;
            font-weight: 800;
          }

          .organisation-address {
            color: #000000;
            font-size: 16px;
          }

          .organisation-member-since {
            color: #939292;
            font-size: 16px;
          }

          .row {
            margin-top: 16px;
            display: flex;
            align-items: center;

            .leave-orga {
              margin-left: 24px;
              cursor: pointer;
              transition: all 0.2s;
            }

            .edit {
              margin: 0;
              cursor: pointer;
              transition: all 0.2s;
              display: flex;
              justify-content: center;
              align-items: center;
              .icon {
                position: relative;
                color: colors.$white-color;
                width: 10px;
                height: 10px;
                margin-right: 7px;
              }
              span {
                position: relative;
              }
            }
          }

          .leave-orga {
            color: colors.$light-blue-color;
            font-size: 16px;
            font-weight: bold;
            display: flex;
            align-items: center;
            padding-right: 5px;

            &:hover {
              border-radius: 3px;
              background-color: rgba(colors.$light-blue-color, 0.15);
            }
          }

          .error {
            &:not(input) {
              font-size: 16px;
              color: colors.$red-color;
              margin: 12px 0;
            }
          }

          input {
            width: 280px;
            margin-bottom: 24px;

            &.nomargin {
              margin: 0;
            }

            &.invalid {
              border-color: colors.$red-color;
            }
          }

          &:nth-child(2n) {
            margin-left: 38px;
          }
        }
      }
    }

    &.submit {
      justify-content: flex-end;
      margin-bottom: 32px;

      .main-button {
        margin: 28px 0 0;
      }

      .button-create {
        margin-left: 16px;
      }
    }
  }
}
</style>
